import { ColoursObj, TicketIcon } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useFormatValue } from "../../hooks/useFormatValue";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";

interface IFlightTimesProps {
  originTime?: string;
  originAirportABR?: string;
  duration?: string;
  destinationTime?: string;
  destinationAirportABR?: string;
  timeVariant?: string;
  abrVariant?: string;
  gap?: string;
  withDates?: boolean;
}

export const FlightTimes = ({
  originAirportABR,
  originTime,
  destinationTime,
  destinationAirportABR,
  timeVariant = "bodySubtext",
  abrVariant = "bodyRegular",
  gap = "0px",
  withDates = false,
}: IFlightTimesProps) => {
  const { formatValue } = useFormatValue();
  const { past } = useObjectContext();

  return (
    <Stack sx={{
      gap: gap
    }}>
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <CardText component="p" variant={abrVariant as any} sx={{ alignContent: "center" }}>
          {originAirportABR}
        </CardText>
        <TicketIcon iconColour={past ? ColoursObj.shades.shade2 : ColoursObj.core.secondary} name="Flight_Side" />
        <CardText component="p" variant={abrVariant as any} sx={{ alignContent: "center", textAlign: "end" }}>
          {destinationAirportABR}
        </CardText>
      </Stack>
      {withDates && (
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <CardText component="p" variant="bodySubtext" sx={{ alignContent: "center" }}>
            {formatValue(originTime ?? "", "TF;dd-MM-yyyy")}
          </CardText>

          <CardText component="p" variant="bodySubtext" sx={{ alignContent: "center", textAlign: "end" }}>
            {formatValue(destinationTime ?? "", "TF;dd-MM-yyyy")}
          </CardText>
        </Stack>
      )}
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <CardText variant={timeVariant as any}>{formatValue(originTime ?? "", "time")}</CardText>
        <CardText variant="bodySubtext" sx={{ textAlign: "center" }}>
          {formatValue(originTime ?? "", "timeDifferenceV2", [destinationTime ?? ""])}
        </CardText>
        <CardText component="p" variant={timeVariant as any} sx={{ textAlign: "end" }}>
          {formatValue(destinationTime ?? "", "time")}
        </CardText>
      </Stack>
    </Stack>
  );
};
